import {
    AuthManager,
    CenterManager,
    FileUtils,
    Role,
} from '@cuatroochenta/co-admin-react-library'
import { Paginated, CustomResponse } from '../model/data/common'
import { SocialDocument } from '../model/domain/social-document'
import TaskBase from './TaskBase'
import Urls from './Urls'

export class TaskSocialDocuments extends TaskBase {
    public getSocialDocuments(
        page: number
    ): Promise<Paginated<SocialDocument>> {
        const selectedCenter = CenterManager.getSelectedCenter()

        return fetch(
            `${Urls.URL_GET_PRIVATE_SOCIAL_DOCUMENTS}?center_id=${selectedCenter}&page=${page}&role_id=${Role.ADMIN}`,
            this.getRequestInfo()
        )
            .then((response) => response.json())
            .then((response: CustomResponse<Paginated<SocialDocument>>) => {
                if (!response.success) {
                    throw new Error(
                        Array.isArray(response.error)
                            ? response.error[0]
                            : response.error
                    )
                }

                return response.data!
            })
            .catch((error) => {
                console.error('Error fetching social documents:', error)
                throw error
            })
    }

    public getSocialDocument(
        socialDocumentId: SocialDocument['id']
    ): Promise<SocialDocument> {
        return fetch(
            `${Urls.URL_GET_PRIVATE_SOCIAL_DOCUMENTS}/${socialDocumentId}`,
            this.getRequestInfo()
        )
            .then((response) => response.json())
            .then((response: CustomResponse<SocialDocument>) => {
                if (!response.success) {
                    throw new Error(
                        Array.isArray(response.error)
                            ? response.error[0]
                            : response.error
                    )
                }

                return response.data!
            })
            .catch((error) => {
                console.error('Error fetching social document:', error)
                throw error
            })
    }

    public deleteSocialDocument(
        socialDocumentId: SocialDocument['id']
    ): Promise<void> {
        return fetch(
            `${Urls.URL_GET_PRIVATE_SOCIAL_DOCUMENTS}/${socialDocumentId}`,
            {
                ...this.getRequestInfo(),
                method: 'DELETE'
            }
        )
            .then((response) => response.json())
            .then((response: CustomResponse<void>) => {
                if (!response.success) {
                    throw new Error(
                        Array.isArray(response.error)
                            ? response.error[0]
                            : response.error
                    )
                }
            })
            .catch((error) => {
                console.error('Error deleting social document:', error)
                throw error
            })
    }

    public saveSocialDocument(
        socialDocument: SocialDocument
    ): Promise<SocialDocument> {
        let baseUrl = Urls.URL_GET_PRIVATE_SOCIAL_DOCUMENTS
        if (socialDocument.id) {
            baseUrl += `/${socialDocument.id}`
        }

        const formData = this.getFormDataFromObject(socialDocument)

        return fetch(baseUrl, {
            ...this.getRequestInfo(),
            method: 'POST',
            body: formData,
        })
            .then((response: Response) => response.json())
            .then((response: CustomResponse<SocialDocument>) => {
                if (!response.success) {
                    throw new Error(
                        Array.isArray(response.error)
                            ? response.error[0]
                            : response.error
                    )
                }

                return response.data!
            })
            .catch((error) => {
                console.error('Error creating social document:', error)
                throw error
            })
    }

    public viewSocialDocumentFile(socialDocument: SocialDocument) {
        const token = AuthManager.getAuthToken()
        const url = `${Urls.URL_GET_PUBLIC_SOCIAL_DOCUMENTS}/${socialDocument.id}/file?token=${token}&disposition=inline&key=${Date.now()}`
        FileUtils.viewFileInBrowser(url)
    }

    public downloadSocialDocumentFile(socialDocument: SocialDocument) {
        const token = AuthManager.getAuthToken()
        const url = `${Urls.URL_GET_PUBLIC_SOCIAL_DOCUMENTS}/${socialDocument.id}/file?token=${token}&disposition=attachment&key=${Date.now()}`
        FileUtils.downloadFile(url, socialDocument.filename!)
    }
}
